import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { Dictionary } from '../../index';
/**
 * @private
 */
export class MajorMinorFontScheme {
    constructor() {
        this.fntTypeface = new Dictionary();
        this.fntSchemeList = [];
        this.fntTypeface = new Dictionary();
        this.fntSchemeList = [];
    }
    get fontTypeface() {
        return this.fntTypeface;
    }
    set fontTypeface(value) {
        this.fntTypeface = value;
    }
    get fontSchemeList() {
        return this.fntSchemeList;
    }
    set fontSchemeList(value) {
        this.fntSchemeList = value;
    }
    copyFormat(majorMinor) {
        if (!isNullOrUndefined(majorMinor)) {
            this.fntTypeface = majorMinor.fntTypeface;
            this.fntSchemeList = majorMinor.fntSchemeList;
        }
    }
    destroy() {
        this.fntTypeface = undefined;
        this.fntSchemeList = undefined;
    }
}
